import React, { useEffect, useState } from "react";

import user from "../../../assets/icons/user.svg";
import call from "../../../assets/icons/call.png";
import sms from "../../../assets/icons/sms3.svg";

export default function AddPatientItem({ patient, onSelectionChange, isSelected }) {
  const [marked, setMarked] = useState(isSelected);

  // Update local state when prop changes
  useEffect(() => {
    setMarked(isSelected);
  }, [isSelected]);

  const handleCheckboxChange = () => {
    const newMarked = !marked;
    setMarked(newMarked);
    // Notify parent about selection change
    onSelectionChange(patient.id, newMarked);
  };

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "white",
        boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.15)",
        padding: "10px 20px",
        display: "grid",
        gridTemplateColumns: "30px 1fr",
        borderRadius: 8,
      }}
    >
      <input
        type="checkbox"
        style={{ accentColor: "#6B43B5", width: 15, height: 15, gridRow: "1 / 3", marginTop: 3 }}
        checked={marked}
        onChange={handleCheckboxChange}
      />

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", marginBottom: 5 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 3 }}>
          <img src={user} alt="user" style={{ width: 15 }} />
          <span style={{ fontSize: 14, fontWeight: 400 }}>{patient.first_name} {patient.last_name}</span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <img src={call} style={{ width: 12, height: 12 }} alt="phone" />
          <span style={{ color: "#848696", fontSize: 10 }}>{patient.phone}</span>
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
        <img src={sms} style={{ width: 13, height: 13 }} alt="phone" />
        <span style={{ color: "#848696", fontSize: 10 }}>{patient.email}</span>
      </div>
    </div>
  );
}